export interface ShopProduct {
  id: string;
  title: string;
  description: string;
  price: number;
  category: string;
  city: string;
  image: string;
  sellerName: string;
  sellerPhone: string;
  postedAt: string;
  rating?: number;
  reviewsCount?: number;
}

export const mockShopProducts: ShopProduct[] = [
  {
    id: 'sp-1',
    title: 'Tissu Wax / Pagne africain - 6 yards',
    description: 'Magnifique tissu wax authentique aux motifs traditionnels vibrants. Parfait pour la couture de tenues sur mesure. Qualité premium, couleurs éclatantes.',
    price: 12500,
    category: 'Boutique',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20African%20wax%20print%20fabric%20folded%20and%20stacked%20neatly%20on%20a%20clean%20light%20neutral%20surface%20with%20vibrant%20traditional%20patterns%20in%20warm%20tones%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%20for%20an%20online%20boutique%20storefront%2C%20sharp%20focus%20and%20high%20detail&width=800&height=600&seq=shop-wax-01&orientation=landscape',
    sellerName: 'Ablavi Sodji',
    sellerPhone: '+228 90 11 22 33',
    postedAt: '2026-08-19',
    rating: 4.2,
    reviewsCount: 1201,
  },
  {
    id: 'sp-2',
    title: 'Montre connectée SmartWatch Pro',
    description: 'Montre connectée avec écran AMOLED, suivi cardiaque, notifications et batterie longue durée. Idéale pour le sport et le quotidien.',
    price: 45000,
    category: 'Boutique',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Modern%20black%20smartwatch%20with%20bright%20glowing%20display%20resting%20on%20a%20clean%20light%20grey%20background%2C%20minimal%20ecommerce%20product%20photography%2C%20soft%20studio%20lighting%20with%20gentle%20shadows%2C%20high%20detail%2C%20professional%20online%20shop%20product%20shot&width=800&height=600&seq=shop-watch-01&orientation=landscape',
    sellerName: 'Kofi Agbeko',
    sellerPhone: '+228 90 44 55 66',
    postedAt: '2026-08-18',
    rating: 4.6,
    reviewsCount: 755,
  },
  {
    id: 'sp-3',
    title: 'Sac à main artisanal en cuir',
    description: 'Sac à main fait main en cuir véritable avec finitions artisanales soignées. Élégant, durable et unique. Fabriqué par des artisans locaux.',
    price: 35000,
    category: 'Boutique',
    city: 'Kpalimé',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20brown%20leather%20handbag%20with%20artisan%20stitching%20displayed%20on%20a%20clean%20light%20neutral%20backdrop%2C%20elegant%20minimal%20ecommerce%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20professional%20online%20boutique%20product%20image&width=800&height=600&seq=shop-bag-01&orientation=landscape',
    sellerName: 'Mawuli Kpodar',
    sellerPhone: '+228 91 77 88 99',
    postedAt: '2026-08-17',
    rating: 4.8,
    reviewsCount: 4106,
  },
  {
    id: 'sp-4',
    title: 'Sneakers urbaines - pointure 42',
    description: 'Sneakers modernes et confortables, style urbain. Semelle amortissante, matière respirante. Disponible en plusieurs tailles et coloris.',
    price: 28000,
    category: 'Boutique',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20sneakers%20in%20white%20and%20beige%20tones%20on%20a%20clean%20light%20studio%20background%2C%20minimal%20ecommerce%20product%20photography%2C%20soft%20shadows%20and%20natural%20lighting%2C%20high%20detail%20professional%20online%20store%20product%20shot&width=800&height=600&seq=shop-sneakers-01&orientation=landscape',
    sellerName: 'Yao Amegnaglo',
    sellerPhone: '+228 90 22 33 44',
    postedAt: '2026-08-16',
    rating: 4.4,
    reviewsCount: 892,
  },
  {
    id: 'sp-5',
    title: 'Collier en perles artisanales',
    description: 'Collier fait main avec des perles africaines colorées. Pièce unique qui sublime toutes vos tenues. Bijou authentique et élégant.',
    price: 8000,
    category: 'Boutique',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Handmade%20African%20beaded%20necklace%20and%20bracelet%20set%20displayed%20on%20a%20clean%20white%20surface%20with%20vibrant%20colorful%20beads%2C%20soft%20studio%20lighting%2C%20minimal%20ecommerce%20product%20photography%2C%20professional%20online%20boutique%20product%20image&width=800&height=600&seq=shop-jewelry-01&orientation=landscape',
    sellerName: 'Afi Tossou',
    sellerPhone: '+228 91 55 66 77',
    postedAt: '2026-08-15',
    rating: 4.9,
    reviewsCount: 342,
  },
  {
    id: 'sp-6',
    title: 'Coque de téléphone personnalisée',
    description: 'Coque de protection robuste et personnalisable pour tous modèles de téléphone. Motifs variés, protection renforcée contre les chocs.',
    price: 5000,
    category: 'Boutique',
    city: 'Sokodé',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20with%20colorful%20protective%20case%20on%20a%20clean%20light%20background%2C%20minimal%20ecommerce%20product%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20professional%20online%20store%20product%20shot&width=800&height=600&seq=shop-case-01&orientation=landscape',
    sellerName: 'Komlan Ayité',
    sellerPhone: '+228 90 88 99 00',
    postedAt: '2026-08-14',
    rating: 4.1,
    reviewsCount: 567,
  },
  {
    id: 'sp-7',
    title: 'Robe africaine élégante sur mesure',
    description: 'Robe africaine moderne et élégante, confectionnée sur mesure selon vos mensurations. Tissus de qualité, coupe impeccable.',
    price: 30000,
    category: 'Boutique',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20African-inspired%20modern%20dress%20on%20a%20hanger%20against%20a%20clean%20light%20neutral%20background%2C%20minimal%20ecommerce%20fashion%20product%20photography%2C%20soft%20studio%20lighting%2C%20warm%20tones%2C%20professional%20online%20boutique%20product%20image&width=800&height=600&seq=shop-dress-01&orientation=landscape',
    sellerName: 'Délali Mensah',
    sellerPhone: '+228 91 33 44 55',
    postedAt: '2026-08-13',
    rating: 4.7,
    reviewsCount: 203,
  },
  {
    id: 'sp-8',
    title: 'Panier tissé artisanal - décoration',
    description: 'Panier tissé à la main, parfait pour la décoration ou le rangement. Tissage traditionnel authentique, motifs naturels et chaleureux.',
    price: 15000,
    category: 'Boutique',
    city: 'Kara',
    image: 'https://readdy.ai/api/search-image?query=Handwoven%20African%20basket%20and%20decorative%20home%20items%20arranged%20on%20a%20clean%20light%20surface%2C%20warm%20natural%20tones%2C%20soft%20studio%20lighting%2C%20minimal%20ecommerce%20product%20photography%2C%20professional%20online%20shop%20product%20image&width=800&height=600&seq=shop-basket-01&orientation=landscape',
    sellerName: 'Ekoué Amavi',
    sellerPhone: '+228 90 66 77 88',
    postedAt: '2026-08-12',
    rating: 4.5,
    reviewsCount: 156,
  },
];